module.exports = __webpack_public_path__ + "img/live5.e68c2e52.jpg";